/**
 * Touch-first devices (iPhone, Android) and narrow viewports.
 *
 * Width-only breakpoints miss iPhone Pro Max in landscape (~932px).
 * `(hover: none) and (pointer: coarse)` reliably targets phones/tablets.
 */
import { useMediaQuery } from "./useMediaQuery";

/** Phones/tablets with touch — works in portrait AND landscape. */
export const TOUCH_DEVICE_QUERY = "(hover: none) and (pointer: coarse)";

/** Narrow layout — backup for edge cases / small tablets. */
export const NARROW_VIEWPORT_QUERY = "(max-width: 1023px)";

/** Either condition → static UI (no entrance FX, no ambient loops). */
export const STATIC_UI_MEDIA_QUERY = `${TOUCH_DEVICE_QUERY}, ${NARROW_VIEWPORT_QUERY}`;

export const matchesStaticUIViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.(STATIC_UI_MEDIA_QUERY).matches;

export const useIsMobile = () => useMediaQuery(STATIC_UI_MEDIA_QUERY);

export default useIsMobile;
